import format from '@/plugins/format'

export const DateFormat = (data: any) => {
  if(data == null){
    return '-'
  }
  try {
    return format.dateFormat(data, 'yyyy-MM-dd hh:mm:ss')
  } catch (e) {
    return data
  }
}
export const DateFormat2 = (data: any) => {
  if(data == null){
    return '-'
  }
  try {
    return format.dateFormat(data, 'yyyy-MM-dd')
  } catch (e) {
    return data
  }
}
export const DateFormat3 = (data: any) => {
  if(data == null){
    return '-'
  }
  try {
    return format.dateFormat(data, 'yyyyMMdd')
  } catch (e) {
    return data
  }
}

